export default __webpack_public_path__ + "static/media/creative-agency.712527bd.png";